import { TaskCard } from '@medely/ui-kit';
import React from 'react';
import useDialog from '@mp/hooks/useDialog';
import { TaskCardLayout } from './TaskCard';
import { CalendlyModal } from '../calendlyModal/CalendlyModal';

export const ReescreningAutomationCard = () => {
  const { open, closeDialog, openDialog } = useDialog();

  return (
    <>
      <TaskCardLayout>
        <TaskCard
          iconProps={{ name: 'exclamation-triangle', color: 'error' }}
          title="Screening out of date"
          body="Rescreening is required after 18 months of inactivity."
          onClick={openDialog}
        />
      </TaskCardLayout>
      <CalendlyModal open={open} onClose={closeDialog} />
    </>
  );
};
